<template>
  <div class="form-forgot-password">
    <div class="form-forgot-password__content" v-if="!success">
      <ValidationObserver v-slot="ob" class="form-forgot-password__form">
        <Form
          novalidate
          :valid="true"
          :loading="loading"
          @submit="ob.handleSubmit(submit)"
        >
          <FormGroup>
            <p class="text-sans-base text-center">
              Inserisci la mail con il quale ti sei registrato per riceve il
              link e creare una nuova password.
            </p>
          </FormGroup>

          <template>
            <ValidationProvider
              name="Email"
              rules="required|email"
              mode="aggressive"
              v-slot="v"
            >
              <FormGroup for="UserEmail" :vee-errors="v.errors">
                <InputVue
                  type="email"
                  name="email"
                  id="UserEmail"
                  v-model="email"
                  :disabled="loading"
                  :vee="v"
                ></InputVue>
              </FormGroup>
            </ValidationProvider>
          </template>

          <FormSubmit
            slot="footer"
            class="p-4"
            :disabled="loading || !ob.passed"
            >Resetta Password</FormSubmit
          >
        </Form>
      </ValidationObserver>

      <div class="form-forgot-password__footer mt-4">
        <p>
          Sei già iscritto?
          <a
            href="#"
            @click.prevent="$emit('forgotPassword', false)"
            class="font-bold"
            >Accedi</a
          >
        </p>
      </div>
    </div>

    <div class="form-forgot-password__success" v-if="success">
      <p class="text-sans-lg text-center">
        Abbiamo inoltrato la tua richiesta.
      </p>
      <p class="text-sans-lg text-center mt-4">
        Controlla la tua email per completare il processo.
      </p>
    </div>
  </div>
</template>

<script>
/** Packages */
import axios from 'axios'

/** components */
import Form from '@/components/Form.vue'
import FormGroup from '@/components/FormGroup.vue'
import FormSubmit from '@/components/FormSubmit.vue'
import InputVue from '@/components/fields/InputVue.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  apollo: {
    $client: 'guest',
  },

  components: {
    Form,
    FormGroup,
    FormSubmit,
    InputVue,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      loading: false,
      success: false,
      email: '',
    }
  },

  methods: {
    async submit() {
      this.loading = true

      try {
        await axios.get('/.netlify/functions/forgot-password', {
          params: {
            email: this.email,
            tenant: this.$route.params.tenant,
          },
        })
      } catch (err) {
        console.dir(err)
      }

      this.loading = false
      this.success = true
    },
  },
}
</script>
